<template>
  <v-col cols="12" class="px-0">
    <raster-catalog-fields :value="form" :errors="errors" />
    <field-group
      v-if="isCreate"
      v-model="form.file"
      :error-messages="errors.file || errors.files"
      typeInput="field-file-input"
      :rules="handler.fileRules()"
      accept=".pdf"
      allow-directory
      multiple
      title="Tải GeoPdf"
      :file-state="fileState"
    >
      <template v-slot:file-extra="{ item }">
        <pdf-georef-fields
          v-if="needsGeoref(item)"
          embedded
          :file-name="item.name"
          :srs-list="srsList"
          :invalid="!handler.isFileReady(form, item)"
          :value="handler.georefFor(form, item.name)"
          @input="setGeoref(item.name, $event)"
        />
      </template>
    </field-group>
    <div
      v-if="isCreate && form.pdf_inspecting"
      class="text-caption grey--text mb-2"
    >
      Đang kiểm tra thông tin tọa độ của file PDF...
    </div>
  </v-col>
</template>

<script>
import RasterCatalogFields from './raster-catalog-fields.vue'
import PdfGeorefFields from './pdf-georef-fields.vue'
import { createDatastoreTypeHandler } from '@service/datastore-type'

export default {
  components: { RasterCatalogFields, PdfGeorefFields },
  props: {
    value: { type: Object, default: () => ({}) },
    errors: { type: Object, default: () => ({}) },
    isCreate: Boolean,
    srsList: { type: Array, default: () => [] },
  },
  computed: {
    handler() {
      return createDatastoreTypeHandler('pdf')
    },
    form() {
      return this.value
    },
  },
  watch: {
    'form.file': {
      immediate: true,
      deep: true,
      handler() {
        this.inspectSelectedFiles()
      },
    },
  },
  methods: {
    fileState(file) {
      return this.handler.fileState(file, this.form)
    },
    needsGeoref(file) {
      const state = this.fileState(file)
      return !!(state && state.georef)
    },
    setGeoref(name, value) {
      if (!this.form.pdf_georefs) {
        this.$set(this.form, 'pdf_georefs', {})
      }
      this.$set(this.form.pdf_georefs, name, value)
    },
    inspectSelectedFiles() {
      return this.handler.inspectSelectedFiles(this.form, {
        set: (obj, key, value) => this.$set(obj, key, value),
        del: (obj, key) => this.$delete(obj, key),
      })
    },
  },
}
</script>
